import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './App.css';
import Hero from './pages/Hero';
import Contact from './pages/Contact';
import Navbar from './components/Navbar';
import About from './pages/About';
// import Experience from './pages/Experience';
import Projects from './pages/Projects';
import Resume from './pages/Resume';
import MySkills from './pages/MySkills';
// import Certificates from './pages/Certificates'; // hidden — uncomment to restore
import Line from './components/Line';
import ScrollToTop from './components/ScrollToTop';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';

function AppContent() {
  const { theme } = useTheme();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const translatedTitle = t('seo.title');
    const translatedDescription = t('seo.description');

    document.title = translatedTitle;

    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }
    description.setAttribute('content', translatedDescription);

    const html = document.querySelector('html');
    if (html) {
      const languageCode = (i18n.language || 'en').split('-')[0];
      html.setAttribute('lang', languageCode);
      // Arabic reads right-to-left; everything else is left-to-right
      html.setAttribute('dir', languageCode === 'ar' ? 'rtl' : 'ltr');
    }
  }, [t, i18n.language]);
  
  return (
    <div className={`App ${theme === 'modern' ? 'modern-theme' : 'neobrutalism-theme'}`}>
      <Navbar />
      <Hero />
      {/* <Line />  */}
      <About />
      {/* <Line /> */}
      {/* <WhatIDo /> */}
      {theme === 'neobrutalism' && <Line />}
      <MySkills />
      {theme === 'neobrutalism' && <Line />}
      {/* <Experience /> */}
      <Resume />
      {theme === 'neobrutalism' && <Line />}
      <Projects />
      {theme === 'neobrutalism' && <Line />}
      {/* Certificates section temporarily hidden */}
      {/* <Certificates /> */}
      {/* {theme === 'neobrutalism' && <Line />} */}
      <Contact />
      <ScrollToTop />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
